import { P, A } from '@driftt/tide-core-legacy'

import { CtaTypes } from 'app/modules/playbook/constants'

import UISelect from 'components/shared/UISelect'
import './style.styl'

const getCalendarUserMicrocopy = (ctaType) => {
  if (ctaType === CtaTypes.CHAT) {
    return (
      <P className="calendar-user-microcopy">
        Note: Calendar Users will be skipped because they don’t have permissions to respond to conversations.&nbsp;
        <A href="https://gethelp.drift.com/hc/en-us/articles/360021492813-The-Calendar-Seat" >Learn more</A>
      </P>
    )
  }
  if (ctaType === CtaTypes.MEETING) {
    return (
      <P className="calendar-user-microcopy">
        Note: Calendar users don't have permissions to reply to conversations.&nbsp;
        <A href="https://gethelp.drift.com/hc/en-us/articles/360021492813-The-Calendar-Seat" >Learn more</A>
      </P>
    )
  }
}

const MessageCta = ({
  showCtaCopy,
  showCtaUrl,
  onCtaChange,
  onCtaCopyChange,
  onCtaLinkChange,
  CtaTypeOptions,
  cta,
  hideUrl = false,
  hideCopy = false,
  isOnFreePlan,
  isABMPlaybook,
}) =>
  <span className="playbook-message-cta-fields">
    <div className="playbook-edit-message-heading">CTA Type</div>
    <UISelect options={CtaTypeOptions} value={cta.type} onChange={onCtaChange} disabled={isOnFreePlan}/>
    {isABMPlaybook && getCalendarUserMicrocopy(cta.type)}
    {!!showCtaCopy &&
      !hideCopy &&
      <span>
        <div className="playbook-edit-message-heading">CTA Copy</div>
        <input type="text" onChange={onCtaCopyChange} value={cta.copy || ''} />
      </span>}
    {!!showCtaUrl &&
      !hideUrl &&
      <span>
        <div className="playbook-edit-message-heading">CTA Link</div>
        <input type="url" onChange={onCtaLinkChange} value={cta.url || ''} />
        {!cta.url &&
          <div className="warning">Please enter a fully-qualified URL, ex: https://drift.com</div>}
      </span>}
  </span>

export default MessageCta



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/MessageCta/component.js